import { useStyles } from '@archipro-design/aria';
import { DesignBoardDrawerHeader } from './DesignBoardRIghtSideDrawerHeader';
import { DesignBoardDrawerFooter } from './DesignBoardRightSideDrawerFooter';
import { useDesignBoardPageState } from '../context/DesignBoardContext';
import DesignBoardDrawerSelectPinsBody from './DesignBoardDrawerSelectPinsBody';
import * as S from './RightSideNewBoarderDrawer.style';
import { useFetcher } from '@remix-run/react';
import type { MoveDesignBoardPinsMutation } from 'generated/graphql';
import {
    moveToBoardClicked,
    moveToMoodBoardClicked,
} from './DesignBoardFetchers';
import { useToaster } from '~/modules/root/context/ToasterContext';
import type { OnSucessProps } from '../../hook/use-pin-move-copy-on-sucess-toast';
import { useOnSuccessToast } from '../../hook/use-pin-move-copy-on-sucess-toast';
import { useMemoizedFn } from 'ahooks';

const DesignBoardDrawerMovePinsMain = () => {
    const { dispatch, state } = useDesignBoardPageState();
    const { css } = useStyles();
    const { toast } = useToaster();
    const { onSuccessToast } = useOnSuccessToast();

    const onClose = () => {
        dispatch({
            type: 'CloseDrawer',
        });
    };

    const onError = (errorMessage: string) => {
        toast(errorMessage, { type: 'error' });
    };

    const onSuccess = useMemoizedFn((props: OnSucessProps) => {
        onSuccessToast(props);
        onClose();
    });

    const onClickCreateButton = () => {
        dispatch({
            type: 'MoveDesignBoardPinsCreateNewDrawer',
        });
    };

    const movePinFetcher = useFetcher<MoveDesignBoardPinsMutation>();

    if (!state.pinMoveData) return null;
    const submitToMoodBoard = !!state.pinMoveData.buildHubUrl;

    return (
        <div className={css(S.FormClass)}>
            <DesignBoardDrawerHeader
                {...{ onClose }}
                headerTitle={'Choose location'}
            />
            <DesignBoardDrawerSelectPinsBody
                pinData={state.pinMoveData}
                onSuccess={onSuccess}
                onError={onError}
                actionTaken={'moved'}
                pinFetcher={movePinFetcher}
                pinFetcherFunction={
                    submitToMoodBoard
                        ? moveToMoodBoardClicked
                        : moveToBoardClicked
                }
                inputLabel={'Move to existing board'}
                listButtonLabel={'MOVE'}
            />

            <DesignBoardDrawerFooter
                buttonPrimaryAction={onClickCreateButton}
                submitButtonLabel={'CREATE NEW BOARD'}
            />
        </div>
    );
};

export default DesignBoardDrawerMovePinsMain;
